import cssMobile from '../../css/editorMobile.module.css'
import {useAppDispatch, useAppSelector} from '../../stores/configureStore'
import {selectToolboxTabPanel} from '../../stores/toolbox/toolbox.reducer'
import Graphics from './Graphics'
import AddCaption from './AddCaption'
import Caption from './Caption'
import MaskedPhoto from './MaskedPhoto'
import AllGraphicsModal from './modals/AllGraphicsModal'
import AddPhoto from './AddPhoto'
import Photo from './Photo'
import AddPhotoModal from './modals/AddPhotoModal'
import {useEffect, useState} from 'react'
import {Config} from '../../constants/Config'
import {Img} from '../../models/editor/img'
import {useTranslation} from 'react-i18next'

interface TabPanelsProps {
  isGraphics?: boolean
  textOnly?: boolean
  color?: string
}

export default function TabPanels({
  isGraphics,
  textOnly,
  color,
}: TabPanelsProps) {
  const {t} = useTranslation()
  const {activeTabPanel, selectForMasked} = useAppSelector(
    store => store.toolbox,
  )
  const [controlOpen, setControlOpen] = useState(false)
  const {images, selectedImageId} = useAppSelector(store => store.editor)
  const selectedImage = images.find(
    (image: Img) => image.id === selectedImageId,
  )
  const dispatch = useAppDispatch()
  const isTabPanelClosed = activeTabPanel === null
  const [isGraphicsModalOpen, setIsGraphicsModalOpen] = useState(false)
  const [isPhotoModalOpen, setIsPhotoModalOpen] = useState(false)

  const [isUploading, setIsUploading] = useState(false)

  useEffect(() => {
    if (activeTabPanel === 'PhotoUpload' && selectForMasked !== undefined) {
      setIsPhotoModalOpen(true)
    }
  }, [activeTabPanel, selectForMasked])

  useEffect(() => {
    const selectedImg = images.find(
      (image: Img) => image.id === selectedImageId,
    )
    if (
      activeTabPanel === 'Edit' &&
      selectedImg?.type === 'masked' &&
      selectedImg.inside.length === 1 &&
      selectedImg.inside[0].url ===
        `${Config.websiteUrl}/wp-content/themes/poloforma/assets/mask_placeholder.png`
    ) {
      setIsPhotoModalOpen(true)
      dispatch(
        selectToolboxTabPanel({
          tabPanel: 'PhotoUpload',
          selectForMasked: {
            id: selectedImg.id,
            insideIndex: 0,
          },
        }),
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, activeTabPanel, selectedImageId])

  return (
    <>
      {isUploading && (
        <div className={cssMobile.loadingOverlay}>
          <img
            src="/polotervezo/loading.gif"
            alt="Loading"
            width={120}
            height={120}
          />
        </div>
      )}
      <div
        className={`${cssMobile.tabPanels} ${
          isTabPanelClosed || controlOpen ? cssMobile.closed : ''
        }`}>
        <div className={cssMobile.tabNamesContainer}>
          <div
            className={
              activeTabPanel === 'Graphics' ||
              (activeTabPanel === 'Edit' && selectedImage?.type === 'masked')
                ? cssMobile.activeTabPanel
                : undefined
            }
            onClick={() => {
              if (activeTabPanel === 'Graphics') {
                dispatch(selectToolboxTabPanel({tabPanel: null}))
              } else {
                dispatch(selectToolboxTabPanel({tabPanel: 'Graphics'}))
              }
            }}>
            <span>{t('Grafikák')}</span>
          </div>
          <div
            className={
              (activeTabPanel === 'Edit' &&
                selectedImage?.type !== 'caption' &&
                selectedImage?.type !== 'masked') ||
              activeTabPanel === 'PhotoUpload'
                ? cssMobile.activeTabPanel
                : undefined
            }
            onClick={() => {
              if (activeTabPanel === 'PhotoUpload') {
                dispatch(selectToolboxTabPanel({tabPanel: null}))
              } else {
                dispatch(selectToolboxTabPanel({tabPanel: 'PhotoUpload'}))
              }
            }}>
            <span>{t('Képek')}</span>
          </div>
          <div
            className={
              activeTabPanel === 'AddCaption' ||
              (activeTabPanel === 'Edit' && selectedImage?.type === 'caption')
                ? cssMobile.activeTabPanel
                : undefined
            }
            onClick={() => {
              if (activeTabPanel === 'AddCaption') {
                dispatch(selectToolboxTabPanel({tabPanel: null}))
              } else {
                dispatch(selectToolboxTabPanel({tabPanel: 'AddCaption'}))
              }
            }}>
            <span>{t('Szöveg')}</span>
          </div>
        </div>
        <div className={cssMobile.tabPanelContent}>
          <Graphics
            color={color}
            active={activeTabPanel === 'Graphics'}
            openModal={() => {
              setIsGraphicsModalOpen(true)
            }}
          />
          <AddCaption
            active={activeTabPanel === 'AddCaption'}
            isGraphics={isGraphics}
          />
          <AddPhoto
            active={activeTabPanel === 'PhotoUpload'}
            openModal={() => {
              setIsPhotoModalOpen(true)
            }}
          />
          <Photo
            active={activeTabPanel === 'Edit' && selectedImage?.type === 'url'}
            setControlOpen={setControlOpen}
            openModal={() => {
              setIsPhotoModalOpen(true)
            }}
          />
          <Caption
            active={
              activeTabPanel === 'Edit' && selectedImage?.type === 'caption'
            }
            isGraphics={isGraphics}
            setControlOpen={setControlOpen}
          />
          <MaskedPhoto
            active={
              activeTabPanel === 'Edit' && selectedImage?.type === 'masked'
            }
            setControlOpen={setControlOpen}
            openModal={() => {
              setIsGraphicsModalOpen(true)
            }}
          />
        </div>
      </div>
      <AllGraphicsModal
        closed={!isGraphicsModalOpen}
        closeModal={() => {
          setIsGraphicsModalOpen(false)
        }}
        color={color}
      />
      <AddPhotoModal
        closed={!isPhotoModalOpen}
        closeModal={() => {
          setIsPhotoModalOpen(false)
        }}
        setIsUploading={setIsUploading}
      />
    </>
  )
}
